import type {RouteRecordRaw} from 'vue-router';
import {createPropositionGuard} from '@myparcel-frontend/proposition';

export const pricesRoutes: RouteRecordRaw[] = [
  {
    path: '/prices',
    component: () => import('@/views/Financial/ShippingRates/ShippingRatesIndex.vue'),
    meta: {
      permissions: ['readPriceAmounts'],
    },
    beforeEnter: createPropositionGuard((proposition) => proposition.enableRatesOverview, {
      name: 'dashboard',
    }),
    children: [
      {
        name: 'prices',
        path: '',
        components: {
          shippingRates: () => import('@/views/Financial/ShippingRates/SearchTariffs/ShippingRates.vue'),
        },
        meta: {
          permissions: ['readPriceAmounts'],
          title: (t) => t('finance.rates.tariff', 2),
        },
      },
      {
        path: 'scale',
        children: [
          {
            path: '',
            name: 'prices-scale',
            redirect: {
              name: 'prices-scale-postnl',
            },
            meta: {
              feature: 'page.prices.scale.postnl',
            },
          },
          {
            name: 'prices-scale-postnl',
            path: 'postnl',
            components: {
              shippingRates: () => import('@/views/Financial/ShippingRates/ScalesPostNl/ScalesPostNl.vue'),
            },
            meta: {
              feature: 'page.prices.scale.postnl',
              title: (t) => t('finance.shippingRates.postnlRates'),
            },
          },
          {
            name: 'prices-scale-dhl',
            path: 'dhl',
            components: {
              shippingRates: () => import('@/views/Financial/ShippingRates/ScalesDhl/ScalesDhl.vue'),
            },
            meta: {
              feature: 'page.prices.scale.dhl',
              title: (t) => t('finance.shippingRates.dhlRates'),
            },
          },
          {
            name: 'prices-scale-dpd',
            path: 'dpd',
            components: {
              shippingRates: () => import('@/views/Financial/ShippingRates/ScalesDpd/ScalesDpd.vue'),
            },
            meta: {
              feature: 'page.prices.scale.dpd',
              title: (t) => t('finance.shippingRates.dpdRates'),
            },
          },
        ],
      },
    ],
  },
];
